import React from 'react';
import AboutUsPage from '../templates/about-us/about-us';

export default function AboutUs() {
  return <AboutUsPage />;
}
